﻿//-----------------------------------------------------------------------
//  Layout
//-----------------------------------------------------------------------

.full {
	position: relative;
	width: 100%;
}

.large-wrap {
    @extend %clearfix;
	margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 1200px;
    padding-left: 30px;
    padding-right: 30px;

    @include min(1200px) {
        padding-left: 0;
        padding-right: 0;
    }
}

.wrap {
	@extend %clearfix;
	margin-left: auto;
	margin-right: auto;
	width: 90%;
	max-width: 1060px;

	.wrap {
		width: auto;
	}
}

.wrap__text {
	max-width: 860px;
}


// Placeholders
%mobile-only {
	@include min(768px) {
		display: none;
	}
}

%tablet-only {
	display: none;

	@include min(768px) {
		display: block;
	}

	@include min(960px) {
		display: none;
	}
}

%desktop-only {
	display: none;

	@include min(960px) {
		display: block;
	}
}

%not-desktop {
	@include min(960px) {
		display: none;
	}
}

%mobile-tablet-ib {
	display: none;

	@include min(768px) {
		display: inline-block;
	}

	@include min(960px) {
		display: none;
	}
}

%tablet-only-ib {
	display: none;

	@include min(768px) {
		display: inline-block;
	}

	@include min(960px) {
		display: none;
	}
}

%desktop-only-ib {
	display: none;

	@include min(960px) {
		display: inline-block;
	}
}



%tablet-up {
	display: none;
	@include min(768px) {
		display: block;
	}
}

%desktop-up {
	display: none;
	@include min(960px) {
		display: block;
	}
}


.display-mobile-only {
    @extend %mobile-only;
}

.display-no-mobile {
	@extend %tablet-up;
}


.site-wrap {
	min-height: 100vh;
	overflow: hidden;
	position: relative;
}

.left-col {
	min-height: 1px;

	@include min(768px) {
		float: left;
		width: 33.3333%;
		padding-right: 10px;
	}

	@include min(1024px) {
		width: 25%;
	}
}

.main-col {
	min-height: 1px;
	@include min(768px) {
		float: left;
		width: 66.6666%;
	}

	@include min(1024px) {
		width: 75%;
	}
}


.content-layout {
	+ .content-layout {
		margin-top: 1.4rem;
	}

	+ .content-layout_collapse {
		margin-top: 0;
	}

	+ .content-layout_expand {
		margin-top: 2.8em;
	}
}

.content-layout_wrap {
	display: flex;
	flex-wrap: wrap;
	margin-left: -15px;
	margin-right: -15px;
}

.content-layout_column {
	flex-grow: 1;
	min-width: 250px;
	padding-left: 15px;
	padding-right: 15px;

	+ .content-layout_column {
		margin-top: 30px;

		@include min(768px) {
			margin-top: 0;
		}
	}

	+ .content-layout_column__empty {
		margin-top: 0;
	}

	&.content-layout_column__empty {
		+ .content-layout_column {
			margin-top: 0;
		}
	}

	svg {
		display: initial !important;
		vertical-align: initial !important;
	}
}

.content-layout_centre {
	.content-layout_wrap {
		align-items: center;
	}
}

.content-layout_1 {
	@extend .wrap;
}

.content-layout_1-3 {
	@extend .wrap;

	.content-layout_wrap {
		align-items: top;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;

		@include min(768px) {
			flex-direction: row;
		}
	}

	.content-layout_column {
		&:nth-child(1) {
			@include min(768px) {
				width: 25%;
			}
		}
		&:nth-child(2) {
			@include min(768px) {
				width: 75%;
			}
		}
	}
}

.content-layout_1-1 {
	@extend .wrap;
	@extend .wrap__text;

	.content-layout_wrap {
		align-items: top;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;

		@include min(768px) {
			flex-direction: row;
		}
	}

	.content-layout_column {
		flex-grow: 1;

		@include min(768px) {
			width: 50%;
		}
	}
}
.content-layout_2-1 {
	@extend .wrap;

	.content-layout_wrap {
		align-items: top;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;

		@include min(768px) {
			flex-direction: row;
		}
	}

	.content-layout_column {
		&:nth-child(1) {
			@include min(768px) {
				width: 66.6666%;
			}
		}
		&:nth-child(2) {
			@include min(768px) {
				width: 33.3333%;
			}
		}
	}
}
.content-layout_2-3 {
	@extend .wrap;
	@extend .wrap__text;

	.content-layout_wrap {
		align-items: top;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;

		@include min(768px) {
			flex-direction: row;
		}
	}

	.content-layout_column {
		&:nth-child(1) {
			@include min(768px) {
				width: 40%;
			}
		}
		&:nth-child(2) {
			@include min(768px) {
				width: 60%;
			}
		}
	}
}

.content-layout_1-1-1 {
	@extend .wrap;

	.content-layout_column {
		@include min(768px) {
			flex: 0 0 33.3333%;
		}
	}
}

.content-layout__wide {
	margin-left: 0;
	margin-right: 0;
	max-width: 100%;
	width: auto;
}

.content-layout_5-7 {
	@extend .wrap;

	.content-layout_wrap {
        display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		align-items: flex-start;

		@include min(768px) {
			flex-direction: row;
		}
	}

	.content-layout_column {
        width: 100%;
        
        &:nth-child(1) {
            order: 1;

			@include min(768px) {
                order: 0;
				flex-basis: 58.33%;
                max-width: 58.33%;
			}
		}
		&:nth-child(2) {
            order: 0;

			@include min(768px) {
                order: 1;
				flex-basis: 41.67%;
                max-width: 41.67%;
			}
		}
	}
}

// .content-layout {
// 	display: flex;
// 	margin-left: -15px;
// 	margin-right: -15px;

// 	.col {
// 		flex: 1 0 100%;
// 		padding-left: 15px;
// 		padding-right: 15px;
// 	}
// }

.content-layout__nopadding {
	margin-left: 0;
	margin-right: 0;

	.content-layout_wrap {
		margin-left: 0;
		margin-right: 0;
	}

	.content-layout_column {
		padding-left: 0;
		padding-right: 0;
	}
}


.layout-3 {
	.col {
		flex: 0 0 33.3333%;
	}
}

.layout-2 {
	.col {
		flex: 0 0 50%;
	}
}
.layout-footer {
	padding-top: 40px;
	padding-bottom: 40px;

	@include min(768px) {
		padding-top: 80px;
		padding-bottom: 95px;
	}

	h2 {
		font-size: rem(22);
		font-weight: 700;
		text-transform: uppercase;
	}

	p {
		line-height: 1.625;
	}

	.content-layout_wrap {
		justify-content: center;
	}

	.content-layout_column {
		flex-basis: 100%;
		flex-grow: 1;
		padding-top: 15px;
		padding-bottom: 15px;

		@include min(768px) {
			flex-basis: 25%;
		}

		+ .content-layout_column {
			@include max(767px) {
				border-top: 1px solid $colour-highlight;
			}
		}
	}
	.layout-footer_phone {
		color: inherit;
		font-size: 30px;
		font-weight: 700;
		line-height: 16px;
		text-decoration: none;
	}
	.layout-footer_social {
		line-height: 65px;

		a {
			text-decoration: none;

			+ a {
				margin-left: 30px;
			}

			&:after {
				content: none;
			}

			&:hover {
				path {
					stroke: darken($colour-alt, 10%);
				}
			}
		}

		svg {
			overflow: visible;
		}

		path {
			transition: stroke 0.3s;
		}

		img {
			vertical-align: middle;
		}
	}
	.layout-footer_link {
		color: #26acb5;
		font-weight: 700;
		text-decoration: none;
	}
}